import React from "react";
import { EmailTypeInputProps } from "./email-type-input.props";
import "./email-type-input.styles.scss";
import { useTranslation } from 'react-i18next';
import { Utils } from "../../../utilities/utils";

export const EmailTypeInput: React.FC<EmailTypeInputProps> = (props) => {
    const sanitizedId = props.id.replace(/ /g, "");
    const { t } = useTranslation();

    // Basic email regex
    const emailValidation = new RegExp(
        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
    );

    // Get the initial value from registerOptions
    const initialValue = props.registerOptions?.value;
    console.log(initialValue)

    // Combined validation function
    const validateEmail = (email: string) => {
        console.log(email)
        if (!emailValidation.test(email)) return false;
        return Utils.validateTLD(email);
    };

    let inputAttributes = {
        id: sanitizedId,
        placeholder: props.label,
        type: "text"
    }

    // Register with validation
    if (props.registerOptions) {
        inputAttributes = {
            ...inputAttributes,
            ...props.registerHook(sanitizedId, {
                ...props.registerOptions,
                ...!props.readOnly ? { required: t('forms.email_enter') } : {},
                validate: {
                    validEmail: (value: string) => {
                        validateEmail(initialValue ?? value) || t('forms.email_inv_val');
                    }
                },
            }),
            ...(props.registerOptions.value && { value: props.registerOptions.value })
        };
    } else {
        inputAttributes = {
            ...inputAttributes,
            ...props.registerHook(sanitizedId, {
                required: t('forms.email_enter'),
                validate: {
                    validEmail: (value: string) =>
                        validateEmail(value) || t('forms.email_inv_val'),
                }
            })
        };
    }

    return (
        <div className="email-type-container">
            {(props.label && props.hideLabel !== true) &&
                <label htmlFor={sanitizedId}>
                    {props.label}
                </label>
            }
            {props.errorState && props.errorState.message &&
                <span className="error-style" role="alert">
                    {`${props.errorState.message}`}
                </span>
            }
            <input
                {...inputAttributes}
                className={`${(props.errorState || props.noMatchEmail) && "field-error"} ${props.inputClassName}`}
                aria-invalid={props.errorState ? "true" : "false"}
                data-testid="input-test"
                style={props.style}
                readOnly={props.readOnly ?? false} />
        </div>
    )
};